import { getInvoiceSchedule, uploadInvoiceScheduleDocument } from '../../../../../_services/lender.service'
import { unstable_batchedUpdates } from 'react-dom'
import { FilesManager } from '../../../../../_components/FilesManager'
import React, { useEffect, useState } from 'react'
import { S_FilesSidebar } from '../../ScheduleDetails'

import { FaCaretRight, FaFile } from 'react-icons/fa'

const EXTENSION_REGEX = /\.[0-9a-z]+$/i

export const ScheduleFiles = ({ invoiceSchedule, isClientView, totalInvoices = 0 }) => {
  const [showSidebarFiles, setShowSidebarFiles] = useState(false)
  const [sidebarFilesDownloaded, setSidebarFilesDownloaded] = useState(false)
  const [documents, setDocuments] = useState([])
  const [uploadingDocs, setUploadingDocs] = useState(false)

  useEffect(() => {
    const nonZipDocuments = invoiceSchedule.documents.filter(
      (doc) => doc.document_name.match(EXTENSION_REGEX)[0] !== '.zip'
    )
    setDocuments(nonZipDocuments)
  }, [totalInvoices])

  return (
    <>
      <FilesManager
        allowMultiple={true}
        files={documents}
        isUploading={uploadingDocs}
        onDelete={() =>
          getInvoiceSchedule(invoiceSchedule.id).then((resp) => {
            unstable_batchedUpdates(() => {
              setDocuments(resp.documents.filter((d) => !d.deleted))
            })
          })
        }
        onFilesAccepted={async (files) => {
          setUploadingDocs(true)
          await Promise.all(files.map((f) => uploadInvoiceScheduleDocument(invoiceSchedule.id, f)))
          getInvoiceSchedule(invoiceSchedule.id).then((resp) => {
            unstable_batchedUpdates(() => {
              setDocuments(resp.documents.filter((d) => !d.deleted))
              setUploadingDocs(false)
            })
          })
        }}
        parentId={Number(invoiceSchedule.id)}
        title={`Supporting Documents`}
        viewType={'list'}
      />

      {!isClientView && documents && documents.length > 0 && (
        <S_FilesSidebar galleryShown={showSidebarFiles}>
          <div className={`batch-file-container ${showSidebarFiles ? 'show-files' : 'hide-files'}`}>
            <div
              className={`opener ${showSidebarFiles ? 'opener-open' : ''}`}
              onClick={(e) => {
                setShowSidebarFiles(!showSidebarFiles)
                setSidebarFilesDownloaded(true)
              }}
            >
              {!showSidebarFiles ? <FaFile /> : <FaCaretRight />}
            </div>
            {sidebarFilesDownloaded ? (
              <FilesManager
                allowDelete={false}
                allowExpand={true}
                allowUpload={false}
                draggable={true}
                files={documents}
                title="Batch Files"
                viewType="slimgallery"
              />
            ) : null}
          </div>
        </S_FilesSidebar>
      )}
    </>
  )
}
